import { Component, computed, effect, ElementRef, input, output, signal, viewChild } from '@angular/core';

import { MatCardModule } from '@angular/material/card';
import { LexiconModule } from '@galaxy/lexicon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyStatisticModule } from '@vendasta/galaxy/statistic';
import { Conversation } from '@vendasta/protos/meeting_analysis/v1';
import { ScoreBadgeComponent } from '../../score-badge/score-badge.component';
import { VideoJumpComponent } from '../video-jump/video-jump.component';
import { MatChip, MatChipListbox } from '@angular/material/chips';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';
import { Duration } from '../video-jump/duration/duration.pipe';
import { StatisticComponent } from '../../statistic/statistic.component';
import { NgxChartsModule, PieChartModule } from '@swimlane/ngx-charts';
import { pickColorForName } from '@vendasta/galaxy/avatar';
import { ParticipantComponent } from '../../participants/participant/participant.component';

@Component({
  selector: 'meeting-analysis-insights',
  styleUrls: ['./insights.component.scss'],
  templateUrl: './insights.component.html',
  imports: [
    MatCardModule,
    LexiconModule,
    MatExpansionModule,
    MatIconModule,
    GalaxyStatisticModule,
    ScoreBadgeComponent,
    VideoJumpComponent,
    MatChip,
    MatChipListbox,
    GalaxyTooltipModule,
    Duration,
    StatisticComponent,
    NgxChartsModule,
    PieChartModule,
    ParticipantComponent
],
})
export class InsightsComponent {
  conversation = input.required<Conversation>();
  talkTimeFormatted = computed(() => {
    const conversation = this.conversation();
    return (conversation?.interactionReport?.talkTime || []).map((tt) => {
      return { name: tt.person, value: tt.amount };
    });
  });
  customColors = computed(() => {
    const ttf = this.talkTimeFormatted();
    return ttf.map((tt) => ({ name: tt.name, value: pickColorForName(tt.name) }));
  });
  jumpToTimestamp = output<number>();

  private chartContainer = viewChild.required<ElementRef>('chartContainer');

  chartHeight = signal<number>(0);

  constructor() {
    // We need to wait for the page layout to settle before allowing the chart to size itself.
    effect(() => {
      const convo = this.conversation();
      if (convo) {
        setTimeout(() => {
          this.chartHeight.set(this.chartContainer()?.nativeElement?.offsetHeight || 0);
        }, 10);
      }
    });
  }

  onTimeStampSelected(timestamp: number): void {
    this.jumpToTimestamp.emit(timestamp);
  }
}
